// Общий список для FAQ.tsx (рендер) и generateFaqSchema (JSON-LD на сервере) —
// порядок и состав вопросов должны совпадать в разметке и в структурированных данных.
export const FAQ_IDS = [
  'price',
  'start',
  'crm',
  'guarantee',
  'code',
  'data',
  'time',
  'individuals',
] as const;
